import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
} from "shared/provider-webworker";
import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { AccountLookupService } from "./AccountLookupService";
import { AlgoStrategyLookupService } from "./AlgoStrategyLookupService";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { IAlgoStrategyPromiseLookupService } from "../IAlgoStrategyPromiseLookupService";
import { PromiseLookupService } from "../../impl/PromiseLookupService";
import { ReplicaLookupService } from "../../impl/ReplicaLookupService";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class AlgoStrategyReplicaLookupService
  extends ReplicaLookupService<string, CubiqTS.AlgoStrategyImpl>
  implements IAlgoStrategyPromiseLookupService
{
  constructor(protected factory: ClientMessageBrokerFactory) {
    super(
      factory,
      CubiqTS.AlgoStrategyImpl,
      "AlgoStrategyImpl",
      CubiqTS.ModelUpdateImpl,
      true,
      new AlgoStrategyLookupService(),
    );
  }

  getAlgoStrategy(id: string): Promise<CubiqTS.AlgoStrategyImpl> {
    let request = new UiArguments("getAlgoStrategy");
    let arg1 = new FnArg(id, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, this.VALUE);
  }

  getAllIds(): Promise<Array<string>> {
    let request = new UiArguments("getAllIds");
    request.args = [];
    return this.broker.runOnService(request, PRIMITIVE);
  }
}
